import * as React from 'react';
import { Form, Input } from 'semantic-ui-react';

export interface Datos {
    seleccionado: boolean;
    texto: string;
}

export const inicial: Datos = {
    seleccionado: false,
    texto: '',
};

const checkboxStyle = { marginTop: '1ex' };

interface Props {
    etiquetaCheckbox: string;
    etiquetaInput: string;
    valor: Datos;
    onChange(valor: Datos): void;
}

const DeTerceros: React.FunctionComponent<Props> = props => {
    const { etiquetaCheckbox, etiquetaInput, valor, onChange } = props;

    const requerido = valor.seleccionado;
    const error = valor.seleccionado && valor.texto.length === 0;

    return (
        <div>
            <Form.Checkbox
                label={etiquetaCheckbox}
                checked={valor.seleccionado}
                onChange={(_e, { checked }) => {
                    onChange({ ...valor, seleccionado: checked || false });
                }}
                style={checkboxStyle}
            />

            <Form.Field
                hidden={!valor.seleccionado}
                required={requerido}
                error={valor.seleccionado && valor.texto.length === 0}
            >
                <label>{etiquetaInput}</label>
                <Input
                    placeholder='Ramón Universe López'
                    value={valor.texto}
                    onChange={(_e, { value }) => {
                        onChange({ ...valor, texto: value });
                    }}
                    error={error}
                    required={requerido}
                />
            </Form.Field>
        </div>
    );
};

export default DeTerceros;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/DeTerceros/index.tsx